<template>
  <div class="recruiment">
    <header>
      <Navbar />
    </header>
    <div class="product-header">
      <div class="product_bannnerText">
        <div>招贤纳士</div>
        <div>诚招英才，职等你来，期待你的加入！</div>
      </div>
    </div>
    <div class="recruimentBox">
      <div class="recruimentCont">
        <div>
          展华科技是一家专注于医疗行业信息化建设的高科技企业，我们诚招以下职位，期待你的加入！
        </div>
        <div>咨询电话：400-022-7978</div>
        <div>邮箱：zoukai@zhanhuach.com</div>
      </div>
    </div>
    <div class="job">
      <div class="pth">
        <div class="rerurn" @click="goSupandSer">
          <div>返回上一级</div>
          <div class="returnLeve"><img :src="returnLeve" /></div>
        </div>
      </div>
      <div class="jobTitle">招聘职位</div>
      <div class="redline"></div>
      <div class="jobCont">
        <div class="jobList" v-for="(item, index) in jobList" :key="index">
          <div class="jobBox">
            <div class="redLine"></div>
            <div class="post">{{ item.job }}</div>
            <div class="postCont">
              <div class="list">{{ item.education }}</div>
              <div class="list">{{ item.time }}</div>
              <div class="list">{{ item.description1 }}</div>
              <div class="list">{{ item.description2 }}</div>
              <div class="list">{{ item.description3 }}</div>
              <div class="list">{{ item.description4 }}</div>
              <div class="list">{{ item.description5 }}</div>
              <div class="list">{{ item.description6 }}</div>
              <div class="list">{{ item.description7 }}</div>
            </div>
            <div class="jobfooter">
              <div>{{ item.department }} |</div>
              <div>{{ item.city }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <Root />
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue";
import recruimentBanner from "../../assets/recruimentBanner.png";
import returnLeve from "../../assets/returnLeve.png";
export default {
  name: "recruiment",
  components: {
    Navbar,
    Root,
  },
  data() {
    return {
      returnLeve:returnLeve,
      recruimentBanner: recruimentBanner,
      jobList: [
        {
          job: "前端开发实习生",
          time: "无经验",
          education: "本科",
          description1: "HTML",
          description2: "CSS",
          description3: "Javascript",
          description4: "Vue",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "java实习生",
          time: "经验不限",
          education: "本科",
          description1: "Spring",
          description2: "Spring Boot",
          description3: "Spring MVC",
          description4: "Spring Cloud",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "项目实施实习生",
          time: "无经验",
          education: "本科",
          description1: "实施",
          description2: "沟通表达",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "项目经理",
          time: "5-10年",
          education: "大专",
          description1: "软件项目",
          description2: "Java项目",
          description3: ".NET项目",
          description4: "实施项目",
          description5: "IT项目",
          description6: "大数据项目",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "实施工程师",
          time: "1-3年",
          education: "大专",
          description1: "需求分析",
          description2: "实施",
          description3: "数据库",
          description2: "系统架构",
          description3: "解决方案",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "Java开发工程师",
          time: "1-3年",
          education: "本科",
          description1: "Java",
          description2: "Spring",
          description3: "Oracle",
          department: "技术类",
          city: " 天津·津南区",
        },
        {
          job: "Java开发实习生",
          time: "无经验",
          education: "本科",
          description1: "Java",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "Java开发工程师",
          time: "1-3年",
          education: "本科",
          description1: "Java",
          description2: "Spring",
          description3: "Oracle",
          department: "技术类",
          city: " 天津·河北区",
        },
        {
          job: "Java后端开发工程师",
          time: "3-5年",
          education: "本科",
          description1: "Java",
          description2: "Spring",
          description3: "MySQL",
          description4: "MongoDB",
          description5: "后端开发",
          description6: "Kafka",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "Java开发工程师",
          time: "1-3年",
          education: "本科",
          description1: "Java",
          description2: "Javascript",
          description3: "jQuery",
          description4: "Web前端",
          description5: "HTML/CSS",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "中高级Java开发工程师",
          time: "3-5年",
          education: "本科",
          description1: "Java",
          description2: "Struts",
          description3: "MyBatis",
          description4: "Spring Boot",
          description5: "Spring Cloud",
          department: "技术类",
          city: " 天津市·滨海新区",
        },
        {
          job: "软件实施工程师",
          time: "1-3年",
          education: "大专",
          description1: "Oracle",
          description2: "实施",
          description3: "财务管理",
          description4: "SQL数据库",
          description5: "运维",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "Java开发工程师",
          time: "1-3年",
          education: "本科",
          description1: "Java",
          description2: "Spring",
          description3: "Oracle",
          department: "技术类",
          city: " 天津·北辰区",
        },
        {
          job: ".NET开发工程师",
          time: "1-3年",
          education: "本科",
          description1: ".NET",
          description2: "C#",
          description3: "oracle数据库",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "销售助理",
          time: "1-3年",
          education: "本科",
          description1: "软件商品经理",
          description2: "器械商品经理",
          description3: "客户资源",
          description4: "行业经验",
          department: "技术类",
          city: " 天津市·和平区",
        },
        {
          job: "软件研发工程师",
          time: "3-5年",
          education: "本科",
          description1: "Java",
          description1: "Spring",
          description1: "Linux",
          description1: "HTML",
          department: "技术类",
          city: " 无锡·梁溪区",
        },
      ],
    };
  },
  methods: {
     goSupandSer() {
      this.$router.push({ path: "SupandSer" });
    },
  },
};
</script>
<style scoped>
.redline {
  margin: 0 auto;
  background-color: #e52f22;
  height: 6px;
  width: 60px;
  margin-top: 20px;
  margin-bottom: 50px;
}
.returnLeve {
  margin-left: 10px;
}
.pth {
  margin-top: 30px;
  margin-bottom: 30px;
  height: 22px;
 
}
.rerurn {
  cursor: pointer;
  position: absolute;
  right: 0;
  display: flex;
  height: 30px;
  font-size: 16px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}
footer {
  height: 520px;
  margin-top: 30px;
}
header {
  background-color: #ffffff;
}
.recruiment {
  background-color: #f5f7fa;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/recruimentBanner.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.recruimentBox {
  width: 85%;
  margin: 0 auto;
  height: 100px;
  margin-top: 50px;
  background-color: #ffffff;
}
.recruimentBox :nth-child(2) {
  right: 0;
  position: absolute;
}
.recruimentBox :nth-child(3) {
  right: 0;
  top: 40px;
  position: absolute;
}
.recruimentCont {
  display: flex;
  width: 95%;
  margin: 0 auto;
  position: relative;
  line-height: 62px;
}
.recruimentCont :nth-child(1) {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 400;
}
.recruimentCont :nth-child(2) {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.recruimentCont :nth-child(3) {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}

.job {
  width: 85%;
  margin: 0 auto;
  position: relative;
  padding-bottom: 30px;
}
.jobCont {
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
}
.jobTitle {
  text-align: center;
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
  /* margin-bottom: 50px; */
}
.jobList {
  width: 400px;
  height: 200px;
  margin-bottom: 30px;
  background-color: #ffffff;
}
.jobCont:after {
  content: "";
  width: 30%;
}
.redLine {
  width: 36px;
  height: 6px;
  background-color: #e52f22;
}
.jobBox {
  width: 80%;
  position: relative;
  margin: 0 auto;
}
.post {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 20px;
}
.postCont {
  display: flex;
  font-size: 16px;
  flex-wrap: wrap;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
}
.postCont .list {
  margin-top: 9px;
  background-color: #f4f3f4;
  margin-right: 10px;
}
.jobfooter {
  position: absolute;
  top: 155px;
  display: flex;
  font-size: 16px;
  color: #74798e;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/views/recruiment/index.vue